import Vue from 'vue';
import Router from 'vue-router';
import MainPA from '@/views/MainPA.vue';
import HeaderPA from '@/components/PA/Header.vue';
import TabWidget from '@/components/TabWidget.vue';
import AboutPA from '@/components/PA/About.vue';
import LoginPA from '@/components/PA/Login.vue';
import Home from '@/components/Home.vue';
import {i18n} from "@/main";

Vue.use(Router);

const routerPA = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/:lang/',
            component: MainPA,
            children: [
                {
                    path: 'home/',
                    name: 'home',
                    alias: '',
                    components: {
                        header: HeaderPA,
                        default: Home,
                    },
                },
                {
                    path: 'info/',
                    name: 'info',
                    components: {
                        header: HeaderPA,
                        default: AboutPA,
                    },
                },
                {
                    path: 'maps/',
                    name: 'mappe',
                    components: {
                        header: HeaderPA,
                        default: TabWidget,
                    },
                },
                {
                    path: 'login/',
                    name: 'login',
                    components: {
                        header: HeaderPA,
                        default: LoginPA,
                    },
                },
            ],
        },
    ],
});


routerPA.beforeEach((to, from, next) => {
    const lang = to.params.lang;
    if (!['en', 'it'].includes(lang)) {
        return next('/it');
    }
    if (i18n.locale !== lang) {
        i18n.locale = lang;
    }
    return next();
});

export default routerPA;
